var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5b57efb-7e56-4b55-8cdd-dc10271fc460",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.06 65.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "29.45 64.34 37.34 64.34 45.57 64.34",
    style: {
      fill: "none",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.51,
    y1: 50.3,
    x2: 37.51,
    y2: 64.35,
    style: {
      fill: "none",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.84,422.07a15.93,15.93,0,0,1-31.85,0",
    transform: "translate(-260.47 -387.69)",
    style: {
      fill: "none",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,394a17.8,17.8,0,0,1,0,21.44",
    transform: "translate(-260.47 -387.69)",
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62,389a29,29,0,0,1,.13,31.29",
    transform: "translate(-260.47 -387.69)",
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.63,
    y: 4.01,
    width: 20.02,
    height: 41.35,
    rx: 7.87,
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.31,
    y1: 18.09,
    x2: 34.88,
    y2: 18.09,
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.17,415.44a17.84,17.84,0,0,1,0-21.44",
    transform: "translate(-260.47 -387.69)",
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,420.25a29,29,0,0,1-.13-31.29",
    transform: "translate(-260.47 -387.69)",
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.69,
    y1: 30.32,
    x2: 34.88,
    y2: 30.32,
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.31,
    y1: 24.21,
    x2: 34.88,
    y2: 24.21,
    style: {
      fill: "none",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.c82530a744240ef17a4a7b802cd9d7cb.svg";
export { ForwardRef as ReactComponent };